import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../common/validation.service';
import { AppControl } from '../../../shared/components/components.model';

export const getCheckboxesForAntragstellerLebensunterhalt: (form: FormGroup) => Array<AppControl> = (form: FormGroup) => {
  return [
    {
      control: form.get('bar') as FormControl,
      name: 'bar'
    },
    {
      control: form.get('reiseschecks') as FormControl,
      name: 'reiseschecks'
    },
    {
      control: form.get('kreditkarten') as FormControl,
      name: 'kreditkarten'
    },
    {
      control: form.get('unterkunft') as FormControl,
      name: 'unterkunft'
    },
    {
      control: form.get('befoerderung') as FormControl,
      name: 'befoerderung'
    },
    {
      control: form.get('sonstiges') as FormControl,
      name: 'sonstiges'
    }
  ];
};

export const getCheckboxesForDritteLebensunterhalt: (form: FormGroup) => Array<AppControl> = (form: FormGroup) => {
  return [
    {
      control: form.get("dritteBar") as FormControl,
      name: "bar"
    },
    {
      control: form.get("dritteUnterkunft") as FormControl,
      name: "unterkunft"
    },
    {
      control: form.get("dritteVollstaendigeKostenuebernahme") as FormControl,
      name: "vollstaendigeKostenuebernahme"
    },
    {
      control: form.get("dritteBefoerderung") as FormControl,
      name: "befoerderung"
    },
    {
      control: form.get("dritteSonstiges") as FormControl,
      name: "sonstiges"
    }
  ];
};

export const createReisekostenForm: (fb: FormBuilder, validationService: ValidationService) => FormGroup = (fb: FormBuilder, validationService: ValidationService) => {
  return fb.group({
    isAntragsteller: [null, validationService.getValidators('reisedaten.reisekostenUebernahme.antragsteller')],
    sonstigesText: [null, [Validators.required]],
    bar: [false, validationService.getValidators('reisedaten.lebensunterhalt.bar')],
    reiseschecks: [false, validationService.getValidators('reisedaten.lebensunterhalt.reiseschecks')],
    kreditkarten: [false, validationService.getValidators('reisedaten.lebensunterhalt.kreditkarten')],
    unterkunft: [false, validationService.getValidators('reisedaten.lebensunterhalt.unterkunft')],
    befoerderung: [false, validationService.getValidators('reisedaten.lebensunterhalt.befoerderung')],
    sonstiges: [false, validationService.getValidators('reisedaten.lebensunterhalt.sonstiges')],

    isDritte: [null, []],
    organisation: [null, validationService.getValidators('reisedaten.reisekostenUebernahme.organisation')],
    einlader: [null, validationService.getValidators('reisedaten.reisekostenUebernahme.einlader')],
    dritteSonstigesText: [null, [Validators.required]],
    dritteBar: [false, validationService.getValidators('reisedaten.lebensunterhalt.bar')],
    dritteUnterkunft: [false, []],
    dritteVollstaendigeKostenuebernahme: [false, validationService.getValidators('reisedaten.lebensunterhalt.vollstaendigeKostenuebernahme')],
    dritteBefoerderung: [false, validationService.getValidators('reisedaten.lebensunterhalt.befoerderung')],
    dritteSonstiges: [false, validationService.getValidators('reisedaten.lebensunterhalt.sonstiges')],
  }, { validator: [dritteSpezifiziertValidator, antragStellerCheckboxGroupValidator, dritteCheckboxGroupValidator] });
}

export const dritteSpezifiziertValidator: (control: FormGroup) => {dritteNichtSpezifiziert: boolean} | null = (control: FormGroup) => {
  if (control.value.isAntragsteller !== true && control.value.isDritte !== true ||
    control.value.isDritte === true && control.value.organisation !== true && control.value.einlader !== true) {
    return { dritteNichtSpezifiziert: true };
  }

  return null;
}

export const antragStellerCheckboxGroupValidator: (control: FormGroup) => {invalid: boolean} | null = (control: FormGroup) => {
  const noCheckboxWasClickedIfIsAntragsteller = control.value.isAntragsteller === true && control.value.bar !== true && control.value.reiseschecks !== true &&
    control.value.kreditkarten !== true && control.value.unterkunft !== true &&
    control.value.befoerderung !== true && control.value.sonstiges !== true;

  if (noCheckboxWasClickedIfIsAntragsteller) {
    return { invalid: true };
  }

  return null;
}

export const dritteCheckboxGroupValidator: (control: FormGroup) => {invalid: boolean} | null = (control: FormGroup) => {

  const noCheckboxWasClickedIfIsDritteAndOrganisationOrEinlader = control.value.isDritte === true && (control.value.organisation === true || control.value.einlader === true) &&
    control.value.dritteBar !== true && control.value.dritteUnterkunft !== true &&
    control.value.dritteVollstaendigeKostenuebernahme !== true && control.value.dritteBefoerderung !== true &&
    control.value.dritteSonstiges !== true;

  if (noCheckboxWasClickedIfIsDritteAndOrganisationOrEinlader) {
    return { invalid: true };
  }

  return null;
}
